import React, { Component } from "react";
import { FormGroup, ControlLabel, FormControl, Col } from "react-bootstrap";

function IsSingle({ single, height, status2, value2, placeholder2, ...props }) {
  if (!single) {
    let statusStyle2 = '';
    if(status2 === "disconnected"){
      statusStyle2 = "statusColorDisconnected"
    }
    else if(status2 === "connected"){
      statusStyle2 = "statusColorConnected";
    }
    return (
      <Col md={4}>
        <FormControl className={statusStyle2} style={{ height: 25 + "px" }} {...props} value={value2} placeholder={placeholder2} />
      </Col>
    );
  }

  return (
    <Col md={4}>

    </Col>
  );
}

export class HorizontalFormDoubleInputs extends Component {


  render() {
    const {onChange, status, status2, inputValue,dispatch,label,placeholder2, value2, single, ...props} = this.props;
    let statusStyle = '';
    if(status === "disconnected"){
      statusStyle = "statusColorDisconnected"
    }
    else if(status === "connected"){
      statusStyle = "statusColorConnected";
    }
   // const {label} = this.props.proprieties[0];
    var row = [];

    for (var i = 0; i < this.props.ncols.length; i++) {
      row.push(
        <div key={i} className={this.props.ncols[i]}>
          {/* <FieldGroup {...this.props.proprieties[i]} /> */}
          <FormGroup style={{ marginBottom: -10 + "px" }}>
            <Col componentClass={ControlLabel} style={{ marginTop: 5 + "px" }} md={4}>
              {label}
            </Col>
            <Col md={4}>
              <FormControl className={statusStyle} style={{ height: 25 + "px" }} {...this.props}/>
            </Col>

            <IsSingle {...this.props} />

          </FormGroup>
        </div>
      );
    }
    return <div>{row}</div>;
  }
}

export default HorizontalFormDoubleInputs;
